import {ListRequest} from '../view-model/internal/listrequest';
import {BaseResponse} from './internal/baseresponse';


export class DepositHistoryResult extends BaseResponse {
  data: Array<DepositHistory>;
}

export class BankDepositHistoryResult extends BaseResponse {
  data: BankDepositHistoryObject;
}

export class BankDepositHistoryObject {
  list: Array<DepositHistory>;
  total?: number;
}

export class DepositHistory {
  tran_id: string;
  remitter_name: string;
  tran_date: string;
  tran_time: string;
  tran_amt: string;
  tran_type: string;
  remitter_bank_code: string;
  remitter_account_num: string;
  tran_timestamp: Date;
  account_holder_info: string;
  used: number;
  customer_id_list?: Array<DepositHistoryCustomerInfo>;
}

export class DepositHistoryByChecked{
  tran_id: string;
}

export class DepositHistoryCustomerInfo {
  customer_id?: string;
  customer_idx?: string;
}

export class DepositHistorySearchOption {
  param: string;
  keyword: string;
  from: string;
  to: string;
  refresh: boolean;
}

export class DepositHistoryListSearch extends ListRequest {
  option = new DepositHistorySearchOption();
}



// WEBPACK FOOTER //
// ./src/app/response/deposithistoryresult.ts